import { Component, Prop, Vue } from 'vue-property-decorator'

import { library } from '@fortawesome/fontawesome-svg-core'

import Loader from '@/components/Loader/index.vue'
import api from '@/helpers/fetch'

import { faTrashAlt } from '@fortawesome/free-solid-svg-icons'

library.add(faTrashAlt)

@Component({
	components: {
		Loader,
	},
})
export default class FieldPercentagePortal extends Vue {
	@Prop() type!: string
	@Prop() groupId!: number

	addedFiles: any[] = []
	filesStatus: any[] = []
	uploading = false
	async onFileInput($event) {
		$event.preventDefault()
		const filesInput: any = $event.target
		const files = filesInput.files

		for (let fileIndex = 0; fileIndex < files.length; fileIndex++) {
			const file = files[fileIndex]
			const name = file.name
			const formattedSize = formatBytes(file.size)

			this.addedFiles.push({
				file,
				name,
				size: formattedSize,
			})
		}

		await this.uploadFiles()
	}

	fileInputKey = 0
	async uploadFiles() {
		const form: any = this.$refs.fileForm
		if (form) {
			const formData = new FormData(form)

			const resp = await fetch('/api/reports/upload', {
				method: 'POST',
				body: formData,
			})

			if (resp && resp.ok) {
				this.fileInputKey++
				this.addedFiles = []

				this.$emit('success', true)
			}
		}
	}
}

function formatBytes(bytes, decimals = 2) {
	if (!+bytes) return '0 Bytes'

	const k = 1024
	const dm = decimals < 0 ? 0 : decimals
	const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB']

	const i = Math.floor(Math.log(bytes) / Math.log(k))

	return `${parseFloat((bytes / Math.pow(k, i)).toFixed(dm))} ${sizes[i]}`
}
